var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { class: _vm.parentDOM ? "fileList teafileList" : "fileList" },
    _vm._l(_vm.files, function (item, index) {
      return _c(
        "li",
        { key: index },
        [
          _c("span", { staticClass: "filename" }, [_vm._v(_vm._s(item.name))]),
          _vm._v(" "),
          _vm.parentDOM
            ? _c(
                "el-dropdown",
                { on: { command: (e) => _vm.commandClick(e, item, index) } },
                [
                  _c(
                    "span",
                    { staticClass: "el-dropdown-link" },
                    [
                      _c("el-link", [
                        _vm._v("操作"),
                        _c("i", {
                          staticClass: "el-icon-arrow-down el-icon--right",
                        }),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "fileAddBoard" } },
                        [_vm._v("投屏")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "pushFile" } },
                        [_vm._v("推送")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "downloadFile" } },
                        [_vm._v("下载")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("i", {
                staticClass: "el-icon-download",
                on: {
                  click: function ($event) {
                    return _vm.downloadFile(item.url)
                  },
                },
              }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/fileList.vue?vue&type=template&id=1e720148&scoped=true&
// module id = null
// module chunks = 